import { Field } from 'formik';
import React from 'react';
import Checkbox from './Checkbox';
import { Props as CheckboxProps } from './Checkbox';

interface Props extends Omit<CheckboxProps, 'name'> {
    name: string;
}

export const FormCheckbox: React.FC<Props> = (props) => {
    return <Checkbox {...props} Component={Field} />;
};

export default FormCheckbox;
